import { Component, OnDestroy, OnInit } from '@angular/core';

import { NavBarMenuItem } from 'src/interfaces/utility-interfaces';
import { NavigationService } from 'src/app/services/navigation.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { Subscription } from 'rxjs';
import { UserPreferenceService } from 'src/app/services/user-preference.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit, OnDestroy {

  logo = 'assets/logos/CorHealth-OH-Eng-Pos-RGB.png';
  username: string;
  defaultHomePageUrl: string = NavigationService.patientSearchUrl;
  defaultHomePageSubscription$: Subscription;
  navbarMenuItems: NavBarMenuItem[] = [
    { text: 'Search', active: false, disabled: false, pageUrl: '/patient/search' },
    { text: 'Dashboard', active: false, disabled: false, pageUrl: '/dashboard' },
    { text: 'Reports', active: false, disabled: true, pageUrl: '' },
    { text: 'Support', active: false, disabled: false, pageUrl: '/support' },
  ];

  constructor(
    private navigationService: NavigationService,
    private oauthService: OAuthService,
    private utilService: UtilService,
    private userPreferenceService: UserPreferenceService
  ) {
  }

  ngOnDestroy(): void {
    if (this.defaultHomePageSubscription$) {
      this.defaultHomePageSubscription$.unsubscribe();
      this.defaultHomePageSubscription$ = null;
    }
  }

  ngOnInit(): void {
    if (this.oauthService.hasValidAccessToken()) {
      this.setUserInfo();
    }
    this.defaultHomePageSubscription$ = this.userPreferenceService.defaultHomePageChanged.subscribe((defaultPageCode) => {
      this.defaultHomePageUrl = this.navigationService.getDefaultHomePageByCode(defaultPageCode);
    });
  }

  setUserInfo() {
    const identityClaims: any = this.oauthService.getIdentityClaims();
    this.username = identityClaims.given_name + ' ' + identityClaims.family_name;
  }

  logout(){
    this.navigationService.appLogout(false);
  }
}
